export const DRIVING_SCHOOOL_CONST = Object.freeze({
    ATTESTATION_TYPE: {
        DRIVING_LICENCE: {NAME: 'DRIVING_LICENCE', KEY: 1, PAGE_TITLE: 'Examen permis de conduire'},
        VTC: {NAME: 'VTC', KEY: 2, PAGE_TITLE: 'Examen VTC'},
        BEPECASER: {NAME: 'DRIVING_LICENCE', KEY: 3, PAGE_TITLE: 'Examen BEPECASER'},
    }
});


// WEBPACK FOOTER //
// ./src/driving_school_consts.js